//Transforms firebase object to array
import _ from 'lodash';
export const generic = obj => {
    return Object.keys(obj).map(key => {
        return {
            id: key,
            ...obj[key],
        };
    });
};

export const transformObjectToArray = obj => {
    return Object.keys(obj).map(key => {
        return {
            id: key,
            ...obj[key],
        };
    });
};
//For each item in the array, it creates an object whose key is the value of the passed in "valueAsKey"
export const transformArrayToObject = (array, valueAsKey) => {
    let o = {};
    array.map(a => {
        o[a[valueAsKey]] = _.omit(a, 'id');
        return true
    });
    return o;
};

export const transformUserObjects = users => {
    return Object.keys(users).map(key => ({ name: users[key], id: key }));
};
